import moment from 'moment-timezone';
import React from 'react';
import { classNames } from '../helpers/functions';
import MultiAssetHolder from './MultiAssetHolder';

const EventItem = ({
	date,
	endDate,
	title = '',
	event = {},
	assets = [],
	tags = [],
	onClick,
	condensed,
	timezone,
	allDay,
}) => {
	let mDate =
		date || event?.scheduledDate ? moment(date || event?.scheduledDate) : null;
	const eDate =
		endDate || event?.endDate
			? moment(endDate || event?.endDate).tz(timezone)
			: null;

	if (allDay) {
		mDate = mDate.utc();
	}

	let formattedDate = mDate.isSame(moment().tz(timezone), 'd')
		? 'Today'
		: mDate.isSame(moment().tz(timezone).add(1, 'd'), 'd')
		? 'Tomorrow'
		: mDate.format('dddd, MMM Do, YYYY');

	if (mDate?.get('h') !== 0 && eDate) {
		formattedDate = `${formattedDate}, ${mDate
			.tz(timezone)
			.format('h:mmA')} to ${eDate.format('h:mmA')}`;
	}

	return (
		<div
			className={classNames(
				'border rounded-md mb-3 text-xs',
				condensed ? 'px-5 py-3' : 'px-6 py-4',
				typeof onClick === 'function' && 'cursor-pointer'
			)}
			onClick={typeof onClick === 'function' ? () => onClick() : () => {}}
		>
			<div className="flex items-center justify-between">
				<div>
					{mDate && (
						<div className="text-gray-600 font-normal">
							{formattedDate}
							{/*mDate.format(
								`${
									mDate.isSame(new Date(), 'd')
										? '[Today]'
										: mDate.isSame(moment().add(1, 'd'), 'd')
										? '[Tomorrow]'
										: 'dddd'
								}, MMM Do, YYYY`
							)*/}
						</div>
					)}
					<div className="text-sm max-w-xs font-medium mb-1">{title}</div>
				</div>

				<div className="flex ml-6 items-center">
					{assets?.length ? <MultiAssetHolder assets={assets} /> : null}
				</div>
			</div>
			{tags}
		</div>
	);
};

export default EventItem;
